import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";

export default function SystemChatMainGrid() {
  return (
    <Box sx={{ width: "100%" }}>
      <Outlet />
    </Box>
  );
}
